import DetailedReport from "../../components/Report/CO2DetailedReport";
import "../PageCommon.css";
import "./Report.css";

const CO2DetailedReportPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <DetailedReport />
        </div>
      </div>
    </div>
  );
}

export default CO2DetailedReportPage;